import React from 'react';
import { Tooltip, Typography } from 'antd';
import Highlight from 'react-highlighter';
import styled from 'styled-components';

import ChildCountLabel from '../Dataset/Schema/components/ChildCountLabel';
import PropertyTypeLabel from '../Dataset/Schema/components/PropertyTypeLabel';
import StructuredPropertyTooltip from './StructuredPropertyTooltip';
import { ANTD_GRAY } from '../../constants';
import CardinalityLabel from './CardinalityLabel';

import { PropertyRow } from './types';

const ParentNameText = styled(Typography.Text)`
    color: ${ANTD_GRAY[9]};
    font-size: 16px;
    line-height: 20px;
    word-wrap: break-word;
    display: flex;
    align-items: center;
`;

const ChildNameText = styled(Typography.Text)`
    align-self: stretch;
    color: ${ANTD_GRAY[9]};
    font-size: 14px;
    line-height: 18px;
    word-wrap: break-word;
    display: flex;
    align-items: center;
`;

const NameLabelWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
`;

interface Props {
    propertyRow: PropertyRow;
    filterText?: string;
}

export default function NameColumn({ propertyRow, filterText }: Props) {
    const { structuredProperty } = propertyRow;

    return (
        <>
            {propertyRow.children ? (
                <NameLabelWrapper>
                    <ParentNameText>
                        <Highlight search={filterText}>{propertyRow.displayName}</Highlight>
                    </ParentNameText>
                    {propertyRow.childrenCount ? <ChildCountLabel count={propertyRow.childrenCount} /> : <span />}
                </NameLabelWrapper>
            ) : (
                <NameLabelWrapper>
                    <Tooltip
                        color="#373D44"
                        placement="topRight"
                        title={
                            structuredProperty ? (
                                <StructuredPropertyTooltip structuredProperty={structuredProperty} />
                            ) : (
                                ''
                            )
                        }
                    >
                        <ChildNameText>
                            <Highlight search={filterText}>{propertyRow.displayName}</Highlight>
                        </ChildNameText>
                    </Tooltip>
                    {propertyRow.type ? (
                        <PropertyTypeLabel type={propertyRow.type} dataType={propertyRow.dataType} />
                    ) : (
                        <span />
                    )}
                    {structuredProperty?.definition.allowedValues && (
                        <CardinalityLabel structuredProperty={structuredProperty} />
                    )}
                </NameLabelWrapper>
            )}
        </>
    );
}
